"use strict";

import React from "react";
import ReactDOM from "react-dom";
import PropTypes from 'prop-types';
import Utils from '../Utils.jsx';
import PigNormal from '../../../Content/img/criticalillness/CriticalIllnessPigNormal.gif';
import PigWorried from '../../../Content/img/criticalillness/CriticalIllnessPigWorried.gif';
import PigPanicked from '../../../Content/img/criticalillness/CriticalIllnessPigPanicked.gif';

class CriticalIllnessExpenseCalcTop extends React.Component {
	constructor(props) {
		super(props);

	}

	render() {


		var worriedThreshold = this.props.Worried_Threshold;
		var surplusDeficit = this.props.Surplus_Deficit;
		var totalExpenses = this.props.Total_Expenses;
		var showResults = this.props.Show_Results;
		var whichpig;
		var { dollarResult, ouchOrPhewClass, ctaActionStmt } = "";

		var imgStyle = {
			width: '95%'
		};

		dollarResult = Utils.formatDisplayRange(Math.abs(totalExpenses), "number");
		
		ctaActionStmt = <div><span>Get up to $1,000,000 in Critical Illness Insurance so you can </span>
			<strong>PROTECT&nbsp;YOUR&nbsp;SAVINGS</strong><span> and </span>
			<strong>FOCUS&nbsp;ON&nbsp;YOUR&nbsp;RECOVERY</strong>
		</div>;


		dollarResult = Utils.formatDisplayRange(Math.abs(totalExpenses), "number");
		whichpig = <img src={PigNormal} className="ci-pig ci-pignormal" />;
		
		ouchOrPhewClass = "ci-short";


		var resultsBlock;

		if (showResults) {

			if (surplusDeficit < worriedThreshold) {
				whichpig = <img src={PigPanicked} className="ci-pig ci-pigpanicked" />;
				ouchOrPhewClass = "ci-short ci-panic";
			} else {
				whichpig = <img src={PigWorried} className="ci-pig ci-pigworried" />;
			}

			resultsBlock = <div className="ci-ouchorphewblock"  >
				<div className="ci-ouchorphew">
					<div className="ci-ouchorphewmsg">OUCH!</div>
					<div className="ci-dollar-result">
						<span className="ci-dollaramt">${dollarResult}</span>
					</div>
					<div className="ci-expenses">
						<div className="ci-total">Total</div>
						<div>Expenses</div>
					</div>
				</div>
				<div className="ci-cta">
					<div className="ci-cta-actionstmt">{ctaActionStmt}</div>
					<div className="ci-cta-actionbtntray">
						<a href="../contact" className="ui button primary btn btn-primary btn-lg ci-cta-actionbtn" id="ip-cii-expensecalculatorpage-triggar-get-a-quote-top-banner" >Get a Quote</a>
					</div>
				</div>
			</div>
		} else {
			resultsBlock = <div className="ci-pageintro">
				<div className="pageintro-title">Living in BC is expensive</div>
				<div className="pageintro-subtitle">(we&nbsp;know, we live here too)<br /><br />Critical Illness Insurance can cover life’s expenses at a time when you need to focus on your health.</div>
				<div className="pageintro-cta">
					Calculate your coverage needs<br /><i className="fa fa-arrow-circle-down fa-lg"></i>
				</div>
			</div>
		}
		return <div className={"ci-surplusdeficit " + ouchOrPhewClass}>


			<div>

				<div className="ci-pigblock">
					{whichpig}
				</div>

				{resultsBlock}



			</div>


		</div>

	}
}

CriticalIllnessExpenseCalcTop.propTypes = {
	Worried_Threshold: PropTypes.number,
	Surplus_Deficit: PropTypes.number,
	Total_Expenses: PropTypes.number,
	Show_Results: PropTypes.bool
}

export default CriticalIllnessExpenseCalcTop;